import { HospitalPayload } from '_api/types';

const DefaultNewHospital: HospitalPayload = {
  name: '',
  organizationId: 0,
  phoneNumber: '',
  streetAddress: '',
  city: '',
  state: '',
  zipCode: '',
  canGuardianContactTherapist: false,
  status: 'ACTIVE',
};

export default DefaultNewHospital;
